"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var cookies_1 = require("../../shared/utils/cookies");
var NextAdapter_1 = require("../../shared/adapters/NextAdapter");
var constants_1 = require("../../shared/utils/constants");
function handelCallback(req, res, options) {
    if (options === void 0) { options = {}; }
    if (req.method !== 'POST') {
        res.setHeader('Allow', 'POST');
        res.status(405).end('Method Not Allowed');
    }
    var cookieOptions = tslib_1.__assign(tslib_1.__assign({}, constants_1.COOKIE_OPTIONS), options.cookieOptions);
    var _a = req.body, event = _a.event, session = _a.session;
    if (!event)
        throw new Error('Auth event missing!');
    if (event === 'SIGNED_IN') {
        if (!session)
            throw new Error('Auth session missing!');
        cookies_1.setCookies(new NextAdapter_1.NextRequestAdapter(req), new NextAdapter_1.NextResponseAdapter(res), [
            { key: 'access-token', value: session.access_token },
            { key: 'refresh-token', value: session.refresh_token },
            session.provider_token
                ? { key: 'provider-token', value: session.provider_token }
                : null
        ].reduce(function (acc, token) {
            var _a;
            if (token) {
                acc.push({
                    name: cookieOptions.name + "-" + token.key,
                    value: token.value,
                    domain: cookieOptions.domain,
                    maxAge: (_a = cookieOptions.lifetime) !== null && _a !== void 0 ? _a : 0,
                    path: cookieOptions.path,
                    sameSite: cookieOptions.sameSite
                });
            }
            return acc;
        }, []));
    }
    if (event === 'SIGNED_OUT') {
        cookies_1.setCookies(new NextAdapter_1.NextRequestAdapter(req), new NextAdapter_1.NextResponseAdapter(res), ['access-token', 'refresh-token', 'provider-token'].map(function (key) { return ({
            name: cookieOptions.name + "-" + key,
            value: '',
            maxAge: -1
        }); }));
    }
    res.status(200).json({});
}
exports.default = handelCallback;
//# sourceMappingURL=callback.js.map